"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRoute = void 0;
const provider_1 = __importDefault(require("../../core/provider"));
const routing_token_1 = require("../routing-token");
const validateRoute = (routeSegments, entry, hasChild = false) => {
    const token = (0, provider_1.default)(routing_token_1.RoutingToken);
    if (hasChild) {
        if (routeSegments.length > entry.length) {
            return false;
        }
        for (let i = 0; i < routeSegments.length; i++) {
            const routeSegment = routeSegments[i];
            const entrySegment = entry[i];
            if (routeSegment.startsWith(':')) {
                token.current = {
                    hash: routeSegments,
                    variables: entry,
                };
                continue;
            }
            if (routeSegment !== entrySegment) {
                return false;
            }
        }
    }
    else {
        if (routeSegments.length !== entry.length) {
            return false;
        }
        for (let i = 0; i < routeSegments.length; i++) {
            const routeSegment = routeSegments[i];
            const entrySegment = entry[i];
            if (routeSegment.startsWith(':')) {
                token.current = {
                    hash: routeSegments,
                    variables: entry,
                };
                continue;
            }
            if (routeSegment !== entrySegment) {
                return false;
            }
        }
    }
    return true;
};
exports.validateRoute = validateRoute;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGUtcm91dGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcGFja2FnZXMvcm91dGluZy91dGlscy92YWxpZGF0ZS1yb3V0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxtRUFBMEM7QUFDMUMsb0RBQWdEO0FBRXpDLE1BQU0sYUFBYSxHQUFHLENBQzNCLGFBQXVCLEVBQ3ZCLEtBQWUsRUFDZixRQUFRLEdBQUcsS0FBSyxFQUNoQixFQUFFO0lBQ0YsTUFBTSxLQUFLLEdBQUcsSUFBQSxrQkFBTyxFQUFDLDRCQUFZLENBQUMsQ0FBQztJQUVwQyxJQUFJLFFBQVEsRUFBRTtRQUNaLElBQUksYUFBYSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFO1lBQ3ZDLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFFRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsYUFBYSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUM3QyxNQUFNLFlBQVksR0FBRyxhQUFhLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDdEMsTUFBTSxZQUFZLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBRTlCLElBQUksWUFBWSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsRUFBRTtnQkFDaEMsS0FBSyxDQUFDLE9BQU8sR0FBRztvQkFDZCxJQUFJLEVBQUUsYUFBYTtvQkFDbkIsU0FBUyxFQUFFLEtBQUs7aUJBQ2pCLENBQUM7Z0JBQ0YsU0FBUzthQUNWO1lBRUQsSUFBSSxZQUFZLEtBQUssWUFBWSxFQUFFO2dCQUNqQyxPQUFPLEtBQUssQ0FBQzthQUNkO1NBQ0Y7S0FDRjtTQUFNO1FBQ0wsSUFBSSxhQUFhLENBQUMsTUFBTSxLQUFLLEtBQUssQ0FBQyxNQUFNLEVBQUU7WUFDekMsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUVELEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxhQUFhLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQzdDLE1BQU0sWUFBWSxHQUFHLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUN0QyxNQUFNLFlBQVksR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFFOUIsSUFBSSxZQUFZLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxFQUFFO2dCQUNoQyxLQUFLLENBQUMsT0FBTyxHQUFHO29CQUNkLElBQUksRUFBRSxhQUFhO29CQUNuQixTQUFTLEVBQUUsS0FBSztpQkFDakIsQ0FBQztnQkFFRixTQUFTO2FBQ1Y7WUFFRCxJQUFJLFlBQVksS0FBSyxZQUFZLEVBQUU7Z0JBQ2pDLE9BQU8sS0FBSyxDQUFDO2FBQ2Q7U0FDRjtLQUNGO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDLENBQUM7QUFyRFcsUUFBQSxhQUFhLGlCQXFEeEIifQ==